import {wrappedLazy} from '../../../containers/wrappedLazy'

export default wrappedLazy(
  () =>
    import(
      /* webpackChunkName: "ProjectsPopup", webpackPrefetch: true */
      './ProjectsPopup'
    ),
)
